/**
 * Helpers for wiring pages to the snake_case Pro backend.
 * Pages keep camelCase; services convert at the boundary.
 */

const snakeToCamel = (s) => s.replace(/_([a-z0-9])/g, (_, c) => c.toUpperCase());
const camelToSnake = (s) => s.replace(/[A-Z]/g, (c) => '_' + c.toLowerCase());

const mapKeys = (value, fn) => {
  if (value === null || value === undefined || typeof value !== 'object') return value;
  if (Array.isArray(value)) return value.map((v) => mapKeys(v, fn));
  if (value instanceof Date) return value;
  const out = {};
  for (const [k, v] of Object.entries(value)) {
    out[fn(k)] = mapKeys(v, fn);
  }
  return out;
};

// Deep: nested objects and arrays are converted too.
export const keysSnakeToCamel = (value) => mapKeys(value, snakeToCamel);
export const keysCamelToSnake = (value) => mapKeys(value, camelToSnake);

// `{ success, data }` envelope → camelCase data.
export const unwrapData = (response) => keysSnakeToCamel(response?.data?.data ?? null);

// List endpoints return `data` as an array plus `count`.
export const unwrapList = (response) => ({
  items: keysSnakeToCamel(response?.data?.data ?? []),
  count: response?.data?.count ?? 0,
});

// Paged endpoints return a Spring Page in `data`.
export const unwrapPage = (response) => {
  const page = keysSnakeToCamel(response?.data?.data ?? {});
  return {
    content: page.content ?? [],
    totalElements: page.totalElements ?? 0,
    totalPages: page.totalPages ?? 0,
    number: page.number ?? 0,
    size: page.size ?? 0,
  };
};

// Backend ApiResponse carries the message in `error` (validation / state refusals) or `message`.
export const serverMessage = (err, fallback = 'Something went wrong') =>
  err?.response?.data?.error || err?.response?.data?.message || err?.message || fallback;
